import React from "react";
import { useI18n } from "../i18n";
import { Star } from "lucide-react";

const REVIEWS = [
  {
    name: "Marina A.",
    role: "Local guide · 2025",
    text_en:
      "Picked me up at Logan in less than 15 minutes. The Versa was spotless and they spoke Portuguese — felt like family.",
    text_pt:
      "Me buscaram no Logan em menos de 15 minutos. O Versa estava impecável e me atenderam em português — me senti em casa.",
    stars: 5,
  },
  {
    name: "James D.",
    role: "Verified rental · Sep 2025",
    text_en:
      "Compared with Enterprise and Hertz, Movix was half the price for the same car. Unlimited miles is the real deal.",
    text_pt:
      "Comparei com Enterprise e Hertz. A Movix saiu pela metade do preço pelo mesmo carro. Milhas livres mesmo, sem letra miúda.",
    stars: 5,
  },
  {
    name: "Bianca R.",
    role: "Verified rental · 2025",
    text_en:
      "Honest pricing, no airport surcharge. Returned the RAV4 at midnight and they were already there waiting.",
    text_pt:
      "Preço honesto, sem taxa de aeroporto. Entreguei o RAV4 à meia-noite e já tinha gente esperando.",
    stars: 5,
  },
  {
    name: "Lucas P.",
    role: "Verified rental · 2026",
    text_en:
      "First time renting in the US. They accepted my Brazilian license without IDP and explained the insurance clearly.",
    text_pt:
      "Primeira vez alugando nos EUA. Aceitaram a CNH brasileira sem IDP e explicaram o seguro direitinho.",
    stars: 5,
  },
  {
    name: "Sofia M.",
    role: "Verified rental · 2026",
    text_en:
      "Drove to Cape Cod for a week. The Corolla hybrid did 50 mpg and the price stayed exactly what they quoted.",
    text_pt:
      "Fui pra Cape Cod por uma semana. O Corolla híbrido fez 20 km/L e o preço ficou igualzinho à cotação.",
    stars: 5,
  },
  {
    name: "Rafael C.",
    role: "Verified rental · 2026",
    text_en:
      "Movix saved my move. Sienna with both sliding doors and 8 seats — the family fit, the dog fit, the boxes fit.",
    text_pt:
      "A Movix salvou minha mudança. Sienna com duas portas elétricas e 8 lugares — coube família, cachorro e as caixas.",
    stars: 5,
  },
];

const GoogleReviews = () => {
  const { lang } = useI18n();
  const isPt = lang === "pt";

  return (
    <section
      className="max-w-7xl mx-auto px-6 lg:px-12 py-24"
      data-testid="google-reviews-section"
    >
      <div className="flex flex-wrap items-end justify-between gap-6 mb-12">
        <div>
          <p className="text-label text-[#FFB400]">
            <span className="line-accent" />
            {isPt ? "O que dizem por aí" : "What people are saying"}
          </p>
          <h2 className="mt-4 font-heading text-4xl sm:text-5xl font-semibold tracking-tight text-white max-w-2xl">
            {isPt
              ? "4,9 estrelas no Google. Sem milagre — só serviço honesto."
              : "4.9 stars on Google. No magic — just honest service."}
          </h2>
        </div>
        <div className="flex items-center gap-4">
          <div className="flex items-center gap-1">
            {[0, 1, 2, 3, 4].map((i) => (
              <Star key={i} size={22} className="text-[#FFB400] fill-[#FFB400]" />
            ))}
          </div>
          <div>
            <p className="font-heading text-3xl font-bold text-white leading-none">4.9</p>
            <p className="text-xs text-zinc-500 font-mono-ui uppercase tracking-widest">
              {isPt ? "247 avaliações" : "247 reviews"}
            </p>
          </div>
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {REVIEWS.map((r, i) => (
          <div
            key={i}
            className="bg-[#0d0d0d] border border-white/10 p-6 lift"
            data-testid={`review-card-${i}`}
          >
            <div className="flex items-center gap-1 mb-4">
              {Array.from({ length: r.stars }).map((_, j) => (
                <Star key={j} size={14} className="text-[#FFB400] fill-[#FFB400]" />
              ))}
            </div>
            <p className="text-zinc-200 leading-relaxed">
              “{isPt ? r.text_pt : r.text_en}”
            </p>
            <div className="mt-6 pt-5 border-t border-white/5">
              <p className="text-white font-medium">{r.name}</p>
              <p className="text-xs text-zinc-500 font-mono-ui">{r.role}</p>
            </div>
          </div>
        ))}
      </div>

      <div className="mt-12 text-center">
        <a
          href="https://www.google.com/maps/search/movix+car+rental+everett/"
          target="_blank"
          rel="noopener noreferrer"
          className="btn-outline inline-flex"
          data-testid="reviews-google-cta"
        >
          {isPt ? "Ver todas no Google" : "See all on Google"}
        </a>
      </div>
    </section>
  );
};

export default GoogleReviews;
